import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/player.svg` */
export const PlayerSolidIcon = createTripletGlyphIcon('PlayerSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0328 7.35971C14.5644 7.6704 14.5601 8.44019 14.025 8.74533L4.30057 14.291C3.7655 14.5962 3.10102 14.2078 3.10451 13.592L3.16787 2.39981C3.17136 1.78398 3.84019 1.40255 4.37178 1.71324L14.0328 7.35971Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8664 8.27958C16.4644 8.62911 16.4595 9.49512 15.8576 9.83841L4.91761 16.0773C4.31565 16.4206 3.56811 15.9837 3.57204 15.2909L3.64332 2.69969C3.64724 2.00689 4.39969 1.57778 4.99772 1.9273L15.8664 8.27958Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4042 11.0289C21.2016 11.4949 21.1951 12.6496 20.3925 13.1073L5.80583 21.4258C5.00323 21.8835 4.00651 21.301 4.01174 20.3773L4.10679 3.589C4.11202 2.66526 5.11527 2.09311 5.91264 2.55915L20.4042 11.0289Z"
        fill="currentColor"
      />
    </svg>
  ),
});
